import React from 'react';

import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';

import { BaseAgGrid } from 'src/components/BaseAgGrid';
import { IVendorCode } from 'src/types/IVendor';
import { dateFilterOptions } from 'src/util/grid/filter';
import { dateComparator, dateFilterComparator } from 'src/util/grid/sort';

interface IVendorCodesGridProps {
    vendorCodes: IVendorCode[];
}

export const VendorCodesGrid = ({ vendorCodes }: IVendorCodesGridProps) => {
    const colDefs = [
        {
            headerName: 'Catalog code',
            field: 'catalogCode',
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Royalty code',
            field: 'royaltyCode',
            filter: 'agTextColumnFilter'
        },
        {
            headerName: 'Mapping start',
            field: 'mappingStart',
            comparator: dateComparator,
            filter: 'agDateColumnFilter',
            filterParams: {
                filterOptions: dateFilterOptions,
                defaultOption: 'greaterThanOrEqual',
                comparator: dateFilterComparator,
                includeBlanksInLessThan: true,
                includeBlanksInGreaterThan: true
            }
        },
        {
            headerName: 'Mapping end',
            field: 'mappingEnd',
            comparator: dateComparator,
            filter: 'agDateColumnFilter',
            filterParams: {
                filterOptions: dateFilterOptions,
                defaultOption: 'lessThanOrEqual',
                comparator: dateFilterComparator,
                includeBlanksInLessThan: true,
                includeBlanksInGreaterThan: true
            }
        }
    ];

    return (
        <Column>
            <Heading level={4}>Vendor codes</Heading>
            <BaseAgGrid columnDefs={colDefs} rowData={vendorCodes} domLayout={'autoHeight'} />
        </Column>
    );
};
